















































import { ZenyaDialogComponent, ZenyaDialogInjects } from "../dialogs/ZenyaDialog.vue";
import SearchComponent from "../generic/SearchComponent.vue";
import storeHelper from "../../store/store-helper";
import { PortalSearchOptions } from "@/types/portal";
import { Sort, ContentItem } from "@infoland/iprova-api";
import { ContentItemsRequest } from "../../types/ContentItemsRequest";
import SimpleList from "../generic/SimpleList.vue";
import { SimpleListItem } from "../../types/simpleListItem";
import { HyperlinkItem } from "@/types/HyperlinkItem";
import _ from "lodash";
import { GlobalTargetNames, HyperlinkType, SourceType, ModulesIconLookup } from "@/enums";
import Shared from "../../shared";
import { debounce } from "@/utils";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "CreateHyperlink",
    components: { ZenyaDialogComponent, SearchComponent, SimpleList },
    props: {
        sourceType: { type: String as () => SourceType, required: true },
        useSettingsFromPortalId: Number
    },
    data: function () {
        return {
            contentItems: [] as SimpleListItem[],
            searchContentItemsRequest: null as ContentItemsRequest,
            loadingInProgress: false,
            rules: [
                {
                    name: GlobalTargetNames.WebPage,
                    regex: /^(http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
                },
                {
                    name: GlobalTargetNames.Email,
                    regex: /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/
                },
                { name: GlobalTargetNames.UncPath, regex: /^(\\\\[^/\\\]\[":;|<>+=,?* _]+\\[^/\\\]\[":;|<>+=,?*]+)((?:\\[^\\/:*?"<>|]+)*\\?)$/ }
            ],
            urlEmailUncPathAppliedRule: null as number,
            searchText: "",
            hyperlinkItem: null as HyperlinkItem,
            searchClicked: false
        };
    },
    async created() {
        this.searchContentItemsRequest = {
            text_contains: "",
            portal_id: null,
            include_icons: true,
            include_content_type: true,
            sort: Sort.none,
            limit: 25,
            offset: 0,
            use_settings_from_portal_id: this.useSettingsFromPortalId
        } as ContentItemsRequest;
    },
    methods: {
        async closeDialog(hyperlinkItem: HyperlinkItem) {
            this.$emit("close-create-hyperlink", hyperlinkItem);
        },
        async doSearch(options: PortalSearchOptions) {
            this.searchContentItemsRequest.offset = 0;
            this.searchContentItemsRequest.text_contains = options.text && options.text !== "" ? options.text : null;
            this.contentItems = null;
            this.checkForUrlEmailUncPath(options.text);
            this.searchText = options.text;
            await this.loadContentItems();
            this.searchClicked = true;
        },
        getIconName(contentItem: ContentItem) {
            if (contentItem.content_type) {
                contentItem.icon = { icon_color: null, icon_material_design_name: null };
                contentItem.icon.icon_material_design_name = ModulesIconLookup[contentItem.content_type.content_type_id];
            }

            return contentItem.icon ? contentItem.icon.icon_material_design_name : null;
        },
        shouldStillLoadData() {
            return (
                this.searchContentItemsRequest.offset + this.searchContentItemsRequest.limit <
                storeHelper.contentItemsStore.numberOfAvailableContentItemsForHyperlink
            );
        },
        handleScroll: debounce(async function (this: any, e: Event): Promise<void> {
            const offsetHeight: number = (e.target as HTMLElement).offsetHeight;
            const scrollHeight: number = (e.target as HTMLElement).scrollHeight;
            const scrollTop: number = (e.target as HTMLElement).scrollTop;
            if (scrollTop > (scrollHeight - offsetHeight) * 0.9) {
                await this.loadContentItemsOnScroll();
            }
        }, 100),
        async loadContentItemsOnScroll() {
            if (this.shouldStillLoadData()) {
                this.loadingInProgress = true;
                this.searchContentItemsRequest.offset = this.searchContentItemsRequest.offset + this.searchContentItemsRequest.limit;
                await this.loadContentItems();
                this.loadingInProgress = false;
            }
        },
        async loadContentItems() {
            const loadedContentItems = await storeHelper.contentItemsStore.getContentItemsForHyperlinkAsync(this.searchContentItemsRequest);
            const results = this.mapContentItems(loadedContentItems);
            if (results != null) {
                this.contentItems = this.contentItems == null ? results : this.contentItems.concat(results);
            }
        },
        mapContentItems(items: ContentItem[]) {
            return items.map(item => {
                return {
                    id: item.content_item_id,
                    title: this.showIdentifierInTitle && item.identifier ? item.identifier + " - " + item.title : item.title,
                    icon: this.getIconName(item),
                    iconColor: item.icon && item.icon.icon_color,
                    contentItemMini: {
                        content_item_id: item.content_item_id,
                        content_type_id: item.content_type?.content_type_id,
                        source_item_id: item.source_item_id
                    }
                } as SimpleListItem;
            });
        },
        checkForUrlEmailUncPath(searchText: string) {
            this.urlEmailUncPathAppliedRule = null;
            for (let condition of this.rules) {
                if (condition.regex.test(searchText)) {
                    this.urlEmailUncPathAppliedRule = condition.name;
                }
            }
        },
        async createUrlEmailUncPathHyperlink() {
            switch (this.urlEmailUncPathAppliedRule) {
                case GlobalTargetNames.WebPage: {
                    const description =
                        this.searchText.indexOf("http://") > -1 || this.searchText.indexOf("https://") > -1
                            ? this.searchText
                            : "http://" + this.searchText;
                    this.hyperlinkItem = {
                        target: {
                            web_page_url: description,
                            type: HyperlinkType.Webpage
                        },
                        source: { type: this.sourceType },
                        description: description
                    };
                    break;
                }
                case GlobalTargetNames.Email: {
                    this.hyperlinkItem = {
                        target: {
                            email_address: this.searchText,
                            type: HyperlinkType.Email
                        },
                        source: { type: this.sourceType },
                        description: this.searchText
                    };
                    break;
                }
                case GlobalTargetNames.UncPath: {
                    this.hyperlinkItem = {
                        target: { unc_path: this.searchText, type: HyperlinkType.Unc },
                        source: { type: this.sourceType },
                        description: this.searchText
                    };
                    break;
                }
            }
            await this.createHyperlink(this.hyperlinkItem);
        },
        async createContentItemHyperlink(simpleListItem: SimpleListItem) {
            const contentTypeIsDocument = simpleListItem.contentItemMini?.content_type_id === 1;
            this.hyperlinkItem = {
                target: {
                    type: contentTypeIsDocument ? HyperlinkType.Document : HyperlinkType.ContentItem,
                    document_id: contentTypeIsDocument ? simpleListItem.contentItemMini?.source_item_id : null,
                    content_item_id: simpleListItem.id.toString()
                },
                source: { type: SourceType.Favorite },
                description: simpleListItem.title
            };
            await this.createHyperlink(this.hyperlinkItem);
        },
        async createHyperlink(hyperlinkItem: HyperlinkItem) {
            this.hyperlinkItem.id = await storeHelper.hyperlinksStore.createHyperlink(hyperlinkItem);
            this.closeDialog(hyperlinkItem);
        },
        async openOldHyperlinkWizard(): Promise<boolean> {
            window.addEventListener("message", this.addItemMessageCallback, false);
            window.open(Shared.iProvaUrl + `/Management/HyperlinkWizard/HyperlinkWizardWrapper.aspx?sourceType=${this.sourceType}`);
            return false;
        },
        addItemMessageCallback(message): void {
            this.hyperlinkItem = {
                target: null,
                source: null,
                id: message.data.TempHyperlinkID,
                description: message.data.ItemName
            } as HyperlinkItem;
            this.closeDialog(this.hyperlinkItem);
        }
    },
    computed: {
        showIdentifierInTitle(): boolean {
            return storeHelper.portalStore.getPortal(this.useSettingsFromPortalId)?.show_identifier === true;
        },
        createLinkOptionText(): string {
            return this.$t("createHyperlink.createHyperlinkSuggestion", { searchText: this.searchText }).toString();
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        }
    }
});
